<bzg-welcome-landing topTitle="{{ 'AUTOADMIN.TOP_TITLE' | translate }}" middleTitle="{{ 'AUTOADMIN.MIDDLE_TITLE' | translate }}" bottomTitle="{{ 'AUTOADMIN.BOTTOM_TITLE' | translate }}">
  <form #loginForm="ngForm" (ngSubmit)="login()" class="bmc-admin-login">
    <div class="bz-space--stack-m">
     <bzg-input type='email' [(ngModel)]='userName' (blur)="userName = $event.target.value" name="username-input" [required]="true">
      <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
      {{ 'AUTOADMIN.USER_NAME' | translate }}
    </bzg-input>
    </div>
    <div class="bz-space--stack-m">
   <bzg-password name="password-input" [(ngModel)]='password' [required]="true" >
      {{ 'AUTOADMIN.PASSWORD' | translate }}
      <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
    </bzg-password>
    </div>
    <div class="bmc-admin-login__checkbox">
      <a href="javascript:;" (click)="restorePassword()">{{ 'AUTOADMIN.FORGOT_PASSWORD' | translate }}</a>
    </div>
    <button type="submit" [hidden]="true"></button>

    <bzg-button-primary class="bmc-admin-login__button" (click)="login()">{{ 'AUTOADMIN.ENTER' | translate }}</bzg-button-primary>
  </form>
</bzg-welcome-landing>


